import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';

interface FliterBlockPRops {
  children?: React.ReactNode;
  className?: string;
}

const FilterBlock: React.FC<FliterBlockPRops> = ({ children, className }) => (
  <div className={className}>{children}</div>
);

const StyledFilterBlock = styled(FilterBlock)`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  margin-bottom: ${vars.spacingS};
  margin-left: 0;
  margin-right: 0;
  padding: ${vars.spacingL} 0 ${vars.spacingM} 0;
  min-height: 10.7rem;
  @media screen and (min-width: ${vars.breakPointSmallTablet}) {
    justify-content: space-between;
    margin-top: 0;
  }
  @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
    flex-direction: row;
    overflow: visible;
    max-height: 12rem;
    padding: ${vars.spacingL} ${vars.spacingL} ${vars.spacingM} ${vars.spacingL};
    margin-left: -${vars.spacingL};
    margin-right: -${vars.spacingL};
  }

  .ais-ClearRefinements,
  .ais-Menu,
  .ais-RefinementList {
    display: flex;
    flex-wrap: wrap;
  }
  .ais-RefinementList {
    position: relative;
    display: inline-block;
    vertical-align: top;
    z-index: 140;
    margin-bottom: 1rem;
    @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
      margin-bottom: 0;
    }
  }
  .ais-RefinementList-list {
    display: inline-block;
    vertical-align: top;
    width: 15rem;
  }
  .ais-RefinementList-list {
    font-weight: ${vars.fontWeightRegular};
    ${vars.fontSize2}
    border: 0.1rem #999 solid;
    border-radius: 5px;
    background-color: #fff;
    text-align: left;
    list-style-type: none;
  }
  .ais-RefinementList-list.empty {
    opacity: 0.5;
  }
  .ais-RefinementList-item {
    ${vars.fontSize4}
    list-style: none;
  }
  .ais-RefinementList-label {
    display: flex;
    cursor: pointer;
    padding-top: 0.2rem;
    padding-right: 0.2rem;
  }
  .ais-RefinementList-checkbox {
    margin-top: -0.2rem;
    height: 2rem;
  }
  .ais-RefinementList-labelText {
    font-weight: ${vars.fontWeightRegular};
    padding-left: 1rem;
    ${vars.fontSize2}
  }
  .ais-RefinementList-showMore {
    display: block;
    position: absolute;
    top: 0.3rem;
    padding: 1.4rem 1.2rem;
    width: 100%;
    text-align: right;
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
  }
  .ais-ClearRefinements-button,
  .incrementais-RefinementList-showMore {
    ${vars.fontSize2}
    color: ${vars.lightGrey};
    height: 1.4rem;
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
  }
  .ais-ClearRefinements-button {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 6rem;
    height: 7.9rem;
    background-color: ${vars.white};
    ${vars.fontSize2}
    font-weight: ${vars.fontWeightRegular};
    &:hover {
      background-color: ${vars.greyHavens};
    }
  }
  .ais-Menu-list {
    display: inline-block;
    list-style: none;
  }
  .ais-Menu-item {
    display: inline-block;
    margin-left: 3rem;
    ${vars.fontSize4}
  }
  .ais-Menu-link {
    text-decoration: none;
  }
  .ais-Menu-link .ais-Menu-label,
  .ais-Menu-link .ais-Menu-count {
    color: ${vars.lightGrey};
  }
  .ais-Menu-link .ais-Menu-label:hover,
  .ais-Menu-link .ais-Menu-count:hover,
  .ais-ClearRefinements-button:hover,
  .ais-Menu-item--selected .ais-Menu-link .ais-Menu-label,
  .ais-Menu-item--selected .ais-Menu-link .ais-Menu-count,
  .ais-ClearRefinements-button--disabled {
    color: ${vars.coreDarkGrey};
  }

  .ais-sortby-item {
    padding-bottom: 0.5rem;
  }
  .ais-sortby-item button {
    font-weight: ${vars.fontWeightRegular};
    ${vars.fontSize2}
    border: none;
    background-color: transparent;
    cursor: pointer;
    width: 100%;
    text-align: inherit;
  }
`;

export default StyledFilterBlock;
